import { Component, OnInit } from '@angular/core';
import { MainserviceService } from './../mainservice.service';


@Component({
  selector: 'app-promocodes',
  templateUrl: './promocodes.component.html',
  styleUrls: ['./promocodes.component.scss']
})


export class PromocodesComponent implements OnInit {
   
  stats:any;
  allstats: any;
  promocodes:any;

  promoFilter:any = { code: ''}
  shopFilter:any = { shop_name: ''}
  playerFilter:any = { user: ''}
  expiryFilter:any = { expired: ''}
  dateFilter:any = { date: ''}
  
   //initializing p to one
   p: number = 1; 

  constructor(private mainServ: MainserviceService) { }

  ngOnInit() {

    this.getallstats()
    this.getPromocodes()
    this.getstats()

  } 
  
  getPromocodes() {
    this.mainServ.getPromoCodes().subscribe(data => {
        this.promocodes = data
    });
  }
  
  getallstats() {
    this.mainServ.getAllStatistics().subscribe(data => {
      this.allstats = data

    });
  }

  getstats() {
    this.mainServ.getStatistics("promocodes","all") .subscribe(data => {
     var promos =[]
      for (var i in data) {
        var dt = data[i]
        this.stats = dt
      }
    });
  }
  
}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/promocodes/promocodes.component.ts